import React, { memo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import FooterPayment from './FooterPayment/FooterPayment';
import FooterSocial from './FooterSocial/FooterSocial';
import License from './License/License';
import FooterLanguageSwitcher from './FooterLanguageSwitcher';
import FooterMobileApplicationLink from './FooterMobileApplicationLink';
import FooterNavigationMenu from './FooterNavigationMenu';
import FooterUpButton from './FooterUpButton';

const Footer = ({ className }) => {
  return (
    <footer className={cx('footer', className)}>
      <div className="container-block">
        <div className="footer__top">
          <div className="footer__top__wrapper">
            <FooterSocial />
            <FooterLanguageSwitcher />
          </div>
          <FooterUpButton />
        </div>
        <div className="footer__grid">
          <div className="footer__info">
            <FooterNavigationMenu />
            <License EGamingIconSize={46} />
          </div>
          <div className="footer__accept">
            <FooterPayment />
            <FooterMobileApplicationLink />
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default memo(Footer);
